var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "color",
    title: "CSS Color (Strict)",
    description: "Only accepts valid CSS colors: hex, rgb, rgba, hsl, hsla. Optionally allow transparency.",
    type: "field",
    use: {
        namespace: "ua.select.color"
    },
    fields: {
        allowTransparency: {
            title: "Allow Transparency",
            type: "boolean",
            description: "If true, allows colors with transparency (rgba, hsla, 8-digit hex).",
            default: false
        }
    },
    tests: {
        validHex: {
            must: true,
            run: function () {
                return validate({}, "#00ffcc");
            }
        },
        validRGB: {
            must: true,
            run: function () {
                return validate({}, "rgb(0, 128, 128)");
            }
        },
        validHSL: {
            must: true,
            run: function () {
                return validate({}, "hsl(180, 50%, 50%)");
            }
        },
        invalidRGBAWithoutPermission: {
            throw: "fields.color.invalidAlphaNotAllowed",
            run: function () {
                return validate({ allowAlpha: false }, "rgba(0, 0, 0, 0.5)");
            }
        },
        validRGBAWithPermission: {
            must: true,
            run: function () {
                return validate({ allowAlpha: true }, "rgba(0, 0, 0, 0.5)");
            }
        },
        validHexAlpha: {
            must: true,
            run: function () {
                return validate({ allowAlpha: true }, "#ff00ffaa");
            }
        },
        invalidNamed: {
            throw: "fields.color.invalid",
            run: function () {
                return validate({}, "red");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Color Format",
            description: "Must be a valid CSS color (hex, rgb, hsl, etc).",
            template: "'${value}' is not a recognized color."
        },
        invalidAlphaNotAllowed: {
            title: "Transparency Not Allowed",
            description: "Alpha values are not permitted in this color field.",
            template: "'${value}' includes transparency but 'allowAlpha' is false."
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ value: value });
    }

    var allowAlpha = !!spec.allowTransparency;
    var matched = false;

    var hexNoAlpha = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
    var hexAlpha = /^#([0-9a-f]{4}|[0-9a-f]{8})$/i;

    var rgb = /^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/i;
    var rgba = /^rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(0|1|0?\.\d+)\s*\)$/i;

    var hsl = /^hsl\(\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%\s*\)$/i;
    var hsla = /^hsla\(\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%\s*,\s*(0|1|0?\.\d+)\s*\)$/i;

    if (hexNoAlpha.test(value) || rgb.test(value) || hsl.test(value)) {
        matched = true;
    }

    if (allowAlpha && (hexAlpha.test(value) || rgba.test(value) || hsla.test(value))) {
        matched = true;
    } else if (!allowAlpha && (hexAlpha.test(value) || rgba.test(value) || hsla.test(value))) {
        _.errors.invalidAlphaNotAllowed.throw({ value: value });
    }

    if (!matched) {
        _.errors.invalid.throw({ value: value });
    }
}
module.exports.validate = validate;
